export default "__VITE_ASSET__CiB8ChiI__"